import { State } from '../state';

export const importSummary: State = {
    url: 'imports'
};
